// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_IRPL8){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_2bKl8 .dualColumn_2eR_X{display:flex;align-content:space-between}.nsAddressForm_2bKl8 .dualColumn_2eR_X .firstCol_2h9eL{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_IRPL8",
	"nsAddressForm": "nsAddressForm_2bKl8",
	"dualColumn": "dualColumn_2eR_X",
	"firstCol": "firstCol_2h9eL"
};
module.exports = exports;
